import { render } from "./BatchDownloadLinkContainer.vue?vue&type=template&id=bfe26da8"
import script from "./BatchDownloadLinkContainer.vue?vue&type=script&lang=js"
export * from "./BatchDownloadLinkContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__